/**
 * Serialize an object to a URL query string
 * @param {Object} obj - The object to serialize
 * @param {String} prefix - Optional prefix for nested objects
 * @returns {String} - URL encoded query string
 */
export const serialize = (obj, prefix) => {
  let str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(v !== null && typeof v === "object" ? serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
};

export default serialize;
